import { SelectOptions, SettingsBenefit } from '@spo/logic';
import { useEffect, useState } from 'react';
import { useProductBenefit } from '../../../hooks/useProductBenefit';
import { SelectionInput } from '../../offerPosterModal/selectionInput/SelectionInput';

type UserSegmentationSearchInputProps = {
  selectedProductBenefit: number | null;
  setSelectedProductBenefit: (natureOption: SelectOptions) => void;
  productBenefitList: SettingsBenefit[];
  isSelectDisabled?: boolean;
};

export const ProductBenefitSearchInput = ({
  selectedProductBenefit,
  setSelectedProductBenefit,
  productBenefitList,
  isSelectDisabled,
}: UserSegmentationSearchInputProps) => {
  const [productBenefitOptions, setProductBenefitOptions] = useState<
    SelectOptions[]
  >([]);

  const { data: availableBenefits } = useProductBenefit();

  useEffect(() => {
    if (availableBenefits && availableBenefits.length > 0) {
      const productBenefitListOptions: SelectOptions[] = availableBenefits?.map(
        (availableBenefit) => ({
          label: `${availableBenefit.id} - ${availableBenefit.shortTechnicalLabel}`,
          value: availableBenefit.id,
          name: availableBenefit.shortLabel,
          isDisabled: productBenefitList.some(
            (benefit) => benefit.benefitId === availableBenefit.id,
          ),
        }),
      );
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setProductBenefitOptions(productBenefitListOptions);
    }
  }, [availableBenefits, productBenefitList]);

  const handleEntitySelection = (benefitId: number) => {
    const matchingOption = productBenefitOptions.find(
      (option) => option.value === benefitId,
    );
    matchingOption && setSelectedProductBenefit(matchingOption);
  };

  return (
    <SelectionInput
      entities={productBenefitOptions}
      selectedEntity={selectedProductBenefit}
      entityType="product-benefit"
      handleEntitySelection={handleEntitySelection}
      isSelectDisabled={isSelectDisabled}
      architecture
      hideLabel
    />
  );
};
